import React from "react";
import IframeContainer from "components/IframeContainer";
import ConsultantDashboardPageContent from "./ConsultantDashboardPageContent";
import useConsultantDashboardData from "hooks/ConsultantDashboard/useConsultantDashboardData";

export const ConsultantDashboard = () => {
	const {
		isLoading,
		organizationData,
		fairInfoData,
		chairpersonData,
		financialFormData,
		coChairData,
		eWalletData,
		onlineShoppingData,
		homepageData,
		analyticsData,
		fairId,
	} = useConsultantDashboardData();
	return (
		<IframeContainer
			renderItems={() => (
				<>
					{/* wait to render components until primary request (useEWalletRosterData) is fulfilled */}
					{!isLoading && (
						<>
							<ConsultantDashboardPageContent
								organizationData={organizationData}
								fairInfoData={fairInfoData}
								chairpersonData={chairpersonData}
								financialFormData={financialFormData}
								coChairData={coChairData}
								eWalletData={eWalletData}
								onlineShoppingData={onlineShoppingData}
								homepageData={homepageData}
								fairId={fairId}
								analyticsData={analyticsData}
							/>
						</>
					)}
				</>
			)}
		/>
	);
};

export default ConsultantDashboard;
